"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputBlock = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockType = require("../BlockType");
var _variables = require("@blockwell/variables");
const settings = [{
  title: "Display",
  settings: {
    type: {
      type: "select",
      description: "Type of input shown to the user.",
      enum: ["text", "currency"],
      default: "text"
    },
    label: {
      type: "var",
      description: "Label to show above the input field.",
      variableType: "value",
      singleOnly: true
    },
    help: {
      type: "var",
      description: "Help text to show below the input field.",
      variableType: "value",
      singleOnly: true
    }
  }
}, {
  title: "Variable",
  settings: {
    variable: {
      type: "def",
      title: "Input Variable",
      description: "Variable name where the user's input is stored.",
      default: {
        name: "input"
      }
    }
  }
}];
class InputBlock extends _BlockType.BlockType {
  constructor(param, variableTypes) {
    super();
    (0, _defineProperty2.default)(this, "type", "input");
    (0, _defineProperty2.default)(this, "noChildren", true);
    (0, _defineProperty2.default)(this, "input", void 0);
    (0, _defineProperty2.default)(this, "label", void 0);
    (0, _defineProperty2.default)(this, "help", void 0);
    (0, _defineProperty2.default)(this, "inputType", void 0);
    this.param = param;
    this.input = this.addBlockVariablePair(new _variables.WriteableVariable("value"), param, ["variable"], {
      key: "variable",
      default: "input"
    });
    this.label = this.addBlockParameterVariable("label");
    this.help = this.addBlockParameterVariable("help");
    this.inputType = this.addBlockVariablePair(variableTypes.get("literal"), param, [["type", "value"]]);
  }
  renderValue() {
    return {
      label: _variables.vals.stringValue(this.label.ref.value()),
      help: _variables.vals.stringValue(this.help.ref.value()),
      type: _variables.vals.stringValue(this.inputType.ref.value())
    };
  }
  setValue(value) {
    this.input.type.set(value);
  }
}
exports.InputBlock = InputBlock;
(0, _defineProperty2.default)(InputBlock, "settings", settings);
//# sourceMappingURL=InputBlock.js.map